import api from "./api";

export async function loginRequest(body: { email: string; password: string }) {
	try {
		const response = await api.post("/api/auth/login", body);
		return response.data;
	} catch (error: any) {
		if (!error.response) {
			throw new Error(
				"Não foi possível conectar ao servidor. Verifique sua conexão com a internet."
			);
		}
		throw error;
	}
}
